import { ICategoriaTipoEnsino } from "pages/acessoExclusivo/components/Categoria/CardCategoria";
import { GenericService } from "../Generic.service";



export class CategoriaTipoEnsinoPEService extends GenericService {
    readonly URI: string = '/v1/categoriaTipoEnsinoPaginaExclusiva';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public saveAll(tiposEnsino: ICategoriaTipoEnsino[]) {
        return this.post('', tiposEnsino)
    }

    public deleteCTE(data: ICategoriaTipoEnsino) {
        return this.deleteByBody('', data)
    }
}
